import { render } from "./CustomFooter.vue?vue&type=template&id=d37631d0&scoped=true&ts=true"
import script from "./CustomFooter.vue?vue&type=script&lang=ts"
export * from "./CustomFooter.vue?vue&type=script&lang=ts"

import "./CustomFooter.scss?vue&type=style&index=0&id=d37631d0&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d37631d0"]])

export default __exports__